import React, { useEffect } from 'react';
import { BsSpeedometer, BsFillInfoSquareFill, BsFillPeopleFill, BsBuilding, BsTruck, BsStarFill } from 'react-icons/bs';
import { Tooltip } from 'react-tooltip';
import { locales } from '../../../translations/locales';
import ButtonReturnMod from './ButtonReturnMod';
import { _$ } from '../../../controllers/dom';

const Menu = (props) => {
    const { ModuleRP, locale, theme, setActivePage, activePage, waitingPlayers, accessMenu } = props;

    useEffect(() => {
        if (accessMenu) {
            const categories = ['players', 'buildings', 'vehicleModels', 'skills', 'ranks', 'status', 'incidents', 'functions', 'services', 'geographicSystem'];
            for (const category of categories) {
                if (!accessMenu.includes(category)) {
                    _$(`${category}Menu`).style.display = 'none';
                }
            }
        }
    }, [accessMenu]);

    return (
        <aside className={`menuConfiguration ${theme === 'DARK' ? 'text-light menu-bg-dark' : 'text-dark menu-bg-light'}`}>
            <hr className={`m-0 mb-1 bg-secondary`} />
            <div className="text-center text-secondary">
                <ButtonReturnMod
                    loadGame={ModuleRP.loadGame}
                    theme={theme}
                    locale={locale}
                />
                <>
                    {ModuleRP.userName}
                </>
            </div>
            <hr className={`m-1 bg-secondary`} />
            <ul className="nav flex-column text-center">
                <li
                    className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'Dashboard' ? 'bg-primary text-light' : ''}`}
                    onClick={() => setActivePage('Dashboard')}
                >
                    <span><BsSpeedometer className='mb-1' /> {locales[locale].rightMenu.dashboard}</span>
                </li>
                <li
                    className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'GameInformations' ? 'bg-primary text-light' : ''}`}
                    onClick={() => setActivePage('GameInformations')}
                >
                    <span><BsFillInfoSquareFill className='mb-1' /> {locales[locale].config.informations}</span>
                </li>
                <li className={`nav-item p-2 text-left m-1 menu-nav`}>
                    <span>{locales[locale].config.configure}</span>
                </li>
                <li
                    className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'Players' ? 'bg-primary text-light' : ''}`}
                    onClick={() => setActivePage('Players')}
                    id='playersMenu'
                >
                    <span>
                        <BsFillPeopleFill className='mb-1 mr-1' />
                        {locales[locale].config.players}
                        {waitingPlayers > 0 ?
                            <span
                                className='badge badge-danger p-1 m-1'
                                id='waitingPlayers'
                                data-tip
                                data-tooltip-id='waitingPlayers'
                            >
                                {waitingPlayers}
                                <Tooltip id='waitingPlayers' place='top' effect='solid' className='text-center'>
                                    {locales[locale].config.waitingPlayersInfos}
                                </Tooltip>
                            </span> :
                            ''}
                    </span>
                </li>
                <li
                    className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'Buildings' ? 'bg-primary text-light' : ''}`}
                    onClick={() => setActivePage('Buildings')}
                    id='buildingsMenu'
                >
                    <span><BsBuilding className='mb-1 mr-1' />{locales[locale].config.buildings}</span>
                </li>
                <li
                    className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'VehicleModels' ? 'bg-primary text-light' : ''}`}
                    onClick={() => setActivePage('VehicleModels')}
                    id='vehicleModelsMenu'
                >
                    <span><BsTruck className='mb-1 mr-1' />{locales[locale].config.vehiclesModels}</span>
                </li>
                <li
                    className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'Skills' ? 'bg-primary text-light' : ''}`}
                    onClick={() => setActivePage('Skills')}
                    id='skillsMenu'
                >
                    <span><BsStarFill className='mb-1 mr-1' />{locales[locale].config.skillsFunctions}</span>
                </li>
                <li
                    className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'Ranks' ? 'bg-primary text-light' : ''}`}
                    onClick={() => setActivePage('Ranks')}
                    id='ranksMenu'
                >
                    <span>{locales[locale].config.ranks}</span>
                </li>
                <li
                    className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'Status' ? 'bg-primary text-light' : ''}`}
                    onClick={() => setActivePage('Status')}
                    id='statusMenu'
                >
                    <span>{locales[locale].config.status}</span>
                </li>
                <li
                    className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'IncidentTypes' ? 'bg-primary text-light' : ''}`}
                    onClick={() => setActivePage('IncidentTypes')}
                    id='incidentsMenu'
                >
                    <span>{locales[locale].config.incidentTypes}</span>
                </li>
                <li
                    className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'InterventionGroups' ? 'bg-primary text-light' : ''}`}
                    onClick={() => setActivePage('InterventionGroups')}
                    id='functionsMenu'
                >
                    <span>{locales[locale].config.interventionGroups}</span>
                </li>
                <li
                    className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                cursor-pointer ${activePage === 'Services' ? 'bg-primary text-light' : ''}`}
                    onClick={() => setActivePage('Services')}
                    id='servicesMenu'
                >
                    <span>{locales[locale].config.services}</span>
                </li>
                <li
                    className={`nav-item p-2 rounded m-2 menu-nav menu-nav-${theme === 'DARK' ? 'dark' : 'light'}
                    cursor-pointer ${activePage === 'Sig' ? 'bg-primary text-light' : ''}`}
                    onClick={() => setActivePage('Sig')}
                    id='geographicSystemMenu'
                >
                    <span>{locales[locale].config.sig}</span>
                </li>
            </ul>
        </aside >
    );
};

export default Menu;
